import React from 'react';
interface Column<T> {
  key: string;
  header: string;
  render?: (item: T) => React.ReactNode;
  className?: string;
}
interface TableProps<T> {
  columns: Column<T>[];
  data: T[];
  keyExtractor: (item: T) => string;
  onRowClick?: (item: T) => void;
  emptyMessage?: string;
}
export function Table<T>({
  columns,
  data,
  keyExtractor,
  onRowClick,
  emptyMessage = 'No hay datos disponibles'
}: TableProps<T>) {
  if (!data || data.length === 0) {
    return <div className="text-center py-12 text-gray-500 dark:text-gray-400" data-id="element-4475">
        {emptyMessage}
      </div>;
  }
  // Safely convert a value to a renderable string
  const safeRender = (value: unknown): React.ReactNode => {
    if (value === null || value === undefined) return '';
    if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') return String(value);
    if (value instanceof Date) return value.toLocaleDateString();
    if (typeof value === 'object') return JSON.stringify(value);
    return String(value);
  };
  return <div className="overflow-x-auto" data-id="element-4476">
      <table className="w-full" data-id="element-4477">
        <thead data-id="element-4478">
          <tr className="border-b border-gray-200 dark:border-gray-700" data-id="element-4479">
            {columns.map(column => <th key={column.key} className={`
                  px-4 py-3 text-left text-xs font-semibold
                  text-gray-500 dark:text-gray-400 uppercase tracking-wider
                  ${column.className || ''}
                `} data-id="element-4480">
                {column.header}
              </th>)}
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200 dark:divide-gray-700" data-id="element-4481">
          {data.map(item => <tr key={keyExtractor(item)} onClick={() => onRowClick?.(item)} className={`
                ${onRowClick ? 'cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700/50' : ''}
                transition-colors
              `} data-id="element-4482">
              {columns.map(column => <td key={column.key} className={`
                    px-4 py-3 text-sm text-gray-900 dark:text-gray-100
                    ${column.className || ''}
                  `} data-id="element-4483">
                  {column.render ? column.render(item) : safeRender((item as Record<string, unknown>)[column.key])}
                </td>)}
            </tr>)}
        </tbody>
      </table>
    </div>;
}